<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'personalized-notification-modal.custom-notification'">
      _Notificación personalizada
    </span>
  </div>
  <div class="common-modal__content-scroll-column">
    <p class="common-modal__content-header-info"
      [afTranslate]="'personalized-notification-modal.title-body'">
      _Se ha configurado en este cambio de estado el envío de la siguiente notificación:
    </p>
    <div class="upload-document__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">
          _Campos obligatorios
        </span>
      </div>
      <field-type-text-simple [field]="personalizedNotification.subjectNotification"
        [preSelectItem]="personalizedNotification.customEmail?.customSubject"
        (itemSelected)="itemSelected($event, 'customSubject')">
      </field-type-text-simple>
      @if (personalizedNotification.customNotificationField) {
        <field-type-rich-text-editable
          class="personalized-notification-modal__text-rich"
          [field]="personalizedNotification.customNotificationField"
          [preSelectItem]="personalizedNotification.customEmail.customBody"
          (itemSelected)="itemSelected($event, 'customBody')"></field-type-rich-text-editable>
      }
    </div>
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="cancelTransition()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="handleAccept()">
      <span class="common-button__text-title"
        [afTranslate]="'common.finish'">
        _Finalizar
      </span>
    </button>
  </div>
</div>
